import { createContext, useContext, useEffect, useState } from "react";
import { adminApi, tokenStore } from "./api";

const AdminAuthContext = createContext(null);

export function AdminAuthProvider({ children }) {
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const t = tokenStore.get();
    if (!t) {
      setLoading(false);
      return;
    }
    adminApi
      .me()
      .then(setAdmin)
      .catch(() => tokenStore.clear())
      .finally(() => setLoading(false));
  }, []);

  const login = async (password) => {
    const { access_token } = await adminApi.login(password);
    tokenStore.set(access_token);
    const me = await adminApi.me();
    setAdmin(me);
    return me;
  };

  const logout = () => {
    tokenStore.clear();
    setAdmin(null);
  };

  return (
    <AdminAuthContext.Provider value={{ admin, loading, login, logout }}>
      {children}
    </AdminAuthContext.Provider>
  );
}

export function useAdminAuth() {
  return useContext(AdminAuthContext);
}
